module.exports = __webpack_public_path__ + "img/reward-box01-sp.116b5fab.png";